import script from "./BaseModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModule.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModule.vue?vue&type=style&index=0&id=7b9f6f9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9f6f9e"]])

export default __exports__